import axios from 'axios';
import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Divider from '../../components/common/Divider';
import InputField from '../../components/common/InputField';
import { FaEye, FaEyeSlash } from 'react-icons/fa';
import { Bounce, ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

import BackgroundImage from '../../assets/images/about.jpg';
import Logo from '../../assets/images/logo-white.png'

export default function Login() {
    const navigate = useNavigate();
    const [showPassword, setShowPassword] = useState(false);
    const [loginData, setLoginData] = useState({ email: '', password: '', });

    const handleChangeLogin = (name: string, value: string) => {
        setLoginData((prevData) => ({
            ...prevData,
            [name]: value,
        }));
    };

    const handleLogin = async (e: React.FormEvent<HTMLFormElement>) => {
        e.preventDefault();

        try {
            const response = await axios.post('https://api.robinhoodboechout.be/api/v1/auth/login', loginData, {
                headers: {
                    'Content-Type': 'application/json'
                },
                withCredentials: true
            });
            if (response.status === 200) {
                sessionStorage.setItem('access_token', response.data.access_token);
                navigate('/admin/dashboard');
            }
        } catch (error) {
            if (axios.isAxiosError(error)) {
                if (error.response && error.response.status === 401) {
                    toast.error('Het opgegeven email en/of paswoord is incorrect.', {
                        position: 'bottom-right',
                        autoClose: 5000,
                        hideProgressBar: false,
                        closeOnClick: true,
                        pauseOnHover: true,
                        draggable: true,
                        progress: undefined,
                        theme: 'colored',
                        transition: Bounce,
                    });
                }
            } else {
                console.error(error);
                toast.error('Er is iets misgegaan. Probeer het later opnieuw.', {
                    position: 'bottom-right',
                    autoClose: 5000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                    theme: 'colored',
                    transition: Bounce,
                });
            }
        }

    }

    return (
        <>
            <div className='relative flex w-full h-screen px-4 py-6 overflow-hidden bg-white z-1 sm:p-0'>
                <div className='flex flex-col flex-1 p-6 rounded-2xl sm:rounded-none sm:border-0 sm:p-8'>
                    <div className='flex flex-col justify-center flex-1 w-full max-w-md mx-auto'>
                        <div className='mb-5 sm:mb-8'>
                            <h1 className='mb-2 font-bold text-2xl leading-tight'>Beheerder Toegang</h1>
                            <Divider />
                        </div>
                        <form onSubmit={handleLogin}>
                            <div className='space-y-6'>
                                <div>
                                    <label className='mb-1.5 block text-sm font-medium text-gray-700'>
                                        Email <span className='text-error-500'>*</span>
                                    </label>
                                    <InputField name={'email'} type={'email'} required={true} placeholder={'info@robinhoodboechout.be'} onChange={handleChangeLogin} value={loginData.email} />
                                </div>
                                <div>
                                    <label className='mb-1.5 block text-sm font-medium text-gray-700'>
                                        Paswoord <span className='text-error-500'>*</span>
                                    </label>
                                    <div className='relative'>
                                        <InputField name={'password'} type={showPassword ? 'text' : 'password'} required={true} placeholder={'Voer uw paswoord in'} onChange={handleChangeLogin} value={loginData.password} />
                                        <span onClick={() => setShowPassword(!showPassword)} className='absolute z-30 -translate-y-1/2 cursor-pointer right-4 top-1/2'>
                                          {showPassword ? (
                                              <FaEye className='fill-gray-500'/>
                                          ) : (
                                              <FaEyeSlash className='fill-gray-500'/>
                                          )}
                                        </span>
                                    </div>
                                </div>
                                <div>
                                    <button type='submit' className='w-full inline-flex items-center justify-center gap-2 rounded-lg transition bg-primary text-white font-bold px-5 py-3.5 text-sm shadow-theme-xs hover:bg-secondary'>Inloggen</button>
                                    <ToastContainer />
                                </div>
                            </div>
                        </form>
                        <div className='mt-5'>
                            <p className='text-sm font-normal text-center'>
                                Heeft u geen account? Neem contact op met de <a className='text-secondary' href='mailto:yorick.cleerbout@robinhoodboechout.be'>website administrator</a> .
                            </p>
                        </div>
                    </div>
                </div>
                <div className='relative items-center justify-center flex-1 hidden p-8 z-1 lg:flex bg-cover bg-center' style={{ backgroundImage: `url(${BackgroundImage})` }}>
                    <div className='flex flex-col items-center max-w-xs'>
                        <img src={Logo} alt='Logo'/>
                        <p className='text-center text-primary-text'>
                            Welkom bij het Content Management System van Robin Hood Boechout.
                        </p>
                    </div>
                </div>
            </div>
        </>
    );
}